export default __webpack_public_path__ + "static/media/custom-reports-guide-bookmarks.74b2ef09.png";